import React from 'react';
import { Button } from '@appkit4/react-components/button';
import './SetupModal.scss';

interface UnlinkedEntity {
    entityId?: number;
    entityDisplayName?: string | null;
    countryName?: string | null;
}

interface LinkEntityModalProps {
    unlinkedEntities: UnlinkedEntity[];
    visible: boolean;
    onLink: (entityId: number) => void;
    onCreateNew: () => void;
}

const LinkEntityModal: React.FC<LinkEntityModalProps> = ({
    unlinkedEntities,
    visible,
    onLink,
    onCreateNew,
}) => {
    if (!visible) return null;

    return (
        <div className="setup-modal">
            <div className="setup-modal__backdrop" />
            <div
                role="dialog"
                aria-label="Link Entity to Time Period"
                className="setup-modal__dialog"
            >
                <h2 className="setup-modal__title">
                    Link Entity to Time Period
                </h2>
                <div className="setup-modal__body setup-modal__body--tight">
                    <p className="setup-modal__text">
                        Select an existing entity to link to this time period,
                        or create a new one.
                    </p>
                    {unlinkedEntities.map((entity) => (
                        <div
                            key={entity.entityId}
                            className="setup-modal__entity-row"
                        >
                            <div>
                                <strong>{entity.entityDisplayName}</strong>
                                <span className="setup-modal__entity-country">
                                    {entity.countryName}
                                </span>
                            </div>
                            <Button
                                kind="primary"
                                compact
                                onClick={() => {
                                    if (entity.entityId) {
                                        onLink(entity.entityId);
                                    }
                                }}
                            >
                                Link
                            </Button>
                        </div>
                    ))}
                    <div className="setup-modal__actions">
                        <Button kind="secondary" onClick={onCreateNew}>
                            + Create New Entity
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LinkEntityModal;
